var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-slide-y-reverse-transition',[_c('ReadAloud',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPlayerShowing),expression:"isPlayerShowing"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }